import * as types from "../constants/ActionTypes";
import compose from "lib/compose";
import deepEqual from "lib/deepEqual";
import {looseIsTime as isTime} from "kpi/lib/TimeUtils";
import number from "abusesa-js/formats/number";

const isNumber = val => number.parse(val) !== null;
const isAny = val => true;

//abstraction for iterating over both abusesa avents and objects
const each = (item, fn) => {
    if (typeof item.forEach === "function") {
        item.forEach(fn);
    } else {
        Object.keys(item).forEach(key => {
            fn(item[key], key);
        });
    }
};

const datatypes = {
    "time": isTime,
    "number": isNumber,
    "string": isAny
};

const reduceDataTypes = (value, oldTypes = Object.keys(datatypes)) => {
    let result = oldTypes.filter(type => datatypes[type](value));
    return oldTypes.length === result.length ? oldTypes : result;
};

export function reduceDataset(dataset, newdata) {
    if (newdata.length === 0) {
        return dataset;
    }

    const keys = Object.assign({}, dataset.keys);

    newdata.forEach(event => {
        each(event, (value, key) => keys[key] = reduceDataTypes(value, keys[key]));
    });


    let changes = {
        data: dataset.data.concat(newdata),
        //update keys only when it has changed
        keys: deepEqual(keys, dataset.keys) ? dataset.keys : keys
    };

    return {...dataset, ...changes};
}

const handlers = {
    [types.INIT_DATASET]: ({name, url, placeholder, ...rest}, state) => {
        if (state[name] !== void 0 && state[name].placeholder !== true) {
            throw new Error("Dataset " + name + " already exists.");
        }

        let newDataset = {
            ...rest,
            name,
            url,
            data: [],
            keys: {},
            placeholder: !!placeholder,
            done: false
        };

        return {...state, [name]: newDataset};
    },

    [types.COMPLETED_DATASET]: ({name, failed, reason}, state) => {
        let old = state[name];

        if (old === void 0) {
            throw new Error("Dataset needs to be initialized with INIT_DATASET before completing dataset.");
        }

        if (old.done === true) {
            throw new Error("Dataset is already marked completed.");
        }

        let changes = {done: true};
        if (failed) {
            changes.failed = failed;
        }

        if (reason) {
            changes.reason = reason;
        }

        return {...state, [name]: {...old, ...changes}};
    },

    [types.APPEND_TO_DATASET]: ({name, data}, state) => {
        let old = state[name];

        if (old === void 0 || !Array.isArray(old.data)) {
            throw new Error("Dataset needs to be initialized with INIT_DATASET before appending data.");
        }

        if (old.done === true) {
            throw new Error("Cannot append data to dataset that is marked completed.");
        }

        return {...state, [name]: reduceDataset(old, data)};
    },

    [types.INSERT_DATASET]: (action, state) => {
        let handle = compose(
            state => handlers[types.COMPLETED_DATASET](action, state),
            state => handlers[types.APPEND_TO_DATASET](action, state),
            state => handlers[types.INIT_DATASET](action, state)
        );

        return handle(state);
    },

    [types.REMOVE_DATASET]: ({name}, state) => {
        if (state[name] === void 0) {
            throw new Error("Could not remove dataset " + name + " because it did not exist.");
        }

        let newstate = {...state};
        delete newstate[name];
        return newstate;
    }
};

export default function datasetReducer(datasets = {}, action = {}) {
    const {type, ...args} = action;

    if (typeof handlers[type] == "function") {
        if (args.name === void 0) {
            throw new Error("datasetReducer requires actions to have dataset name defined.");
        }

        return handlers[type](args, datasets);
    } else {
        return datasets;
    }
}


// WEBPACK FOOTER //
// ./src/kpi/store/reducers/datasets.js